module.exports = __webpack_public_path__ + "static/media/14.ebc620ac.jpg";